export default "__VITE_ASSET__92ff11f8__"